import { useState } from "react";
import { useDispatch } from "react-redux";
import ColorPickerGradientDynamic from "../../../UI/ColorPicker/ColorPickerGradientDynamic";
import ColorPickerDynamicTwo from "../../../UI/ColorPicker/ColorPickerDynamicTwo";
import { Languages, LanguagesIcon, Palette, X } from "lucide-react";
import DropDownButtonUI from "../DesignElements/DropDownButtonUI";
import ColorPickerDynamic from "../../../UI/ColorPicker/ColorPickerDynamic";
import ImageWithFallback from "../../../UI/ImageFallBack";

const EditorThankYouAndCTA =({leadThemeObject,setLeadObjectFields})=>{
   const dispatch = useDispatch();  
        // const [itemNameTitle,setItemNameTitle] =useState(leadThemeObject?.fullname?.title)
         const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
                {
                  
                  dispatch({type: "CURSOR",payload:true  });
              
                  dispatch({type: "CURSORTEXT",payload:CursorText})
                  dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
                  dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
                }
                 
                const handleMouseLeave = () => {
                  
                  dispatch({type: "CURSOR",payload:false})
              
                  dispatch({type: "CURSORTEXT",payload:""})
              
                  dispatch({type: "CURSORTEXTBG",payload:""})
                  dispatch({type: "CURSORTEXTCOLOR",payload:""})
                
              
              }
                const fonts=[
  {name:"AlumniSansSC-Regular",
  fontFamily:"AlumniSansSCRegular , 'Helvetica Neue',sans-serif"
 }
 ,{name:"AlumniSansSC-Italic",
  fontFamily:"AlumniSansSCItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Regular",
  fontFamily:"InterRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Inter-Italic",
  fontFamily:"InterItalic , 'Helvetica Neue',sans-serif"
 }
,{name:"Lato-Light",
  fontFamily:"LatoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Montserrat-Light",
  fontFamily:"MontserratLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Nunito-Light",
  fontFamily:"NunitoLight , 'Helvetica Neue',sans-serif"
 }
,{name:"OpenSans-Regular",
  fontFamily:"OpenSansRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Poppins-Regular",
  fontFamily:"PoppinsRegular , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Light",
  fontFamily:"RalewayLight , 'Helvetica Neue',sans-serif"
 }
,{name:"Raleway-Thin",
  fontFamily:"RalewayThin , 'Helvetica Neue',sans-serif"
 }
   ]
   const [cardBG, setcardBG] = useState(leadThemeObject?.thankYouPage?.cardBG);
                const [palletcardBG, setPalletcardBG] = useState(false);
                const [palletcardBGGradient, setPalletcardBGGradient] = useState(false);
              
                const [palletItem1BorderBG, setPalletItem1BorderBG] = useState(false);
   const [fontFamilyTitlePopup ,setFontFamilyTitlePopup]  = useState(false);
  
   const [fontFamilySubTitlePopup ,setFontFamilySubTitlePopup]  = useState(false);
  
   const [CTAState ,setCTAState]  = useState(leadThemeObject?.thankYouPage?.CTAButton.type);
  
              
                const [titleColor, settitleColor] = useState(leadThemeObject?.thankYouPage?.titleColor);
                const [pallettitleColor, setPallettitleColor] = useState(false);
                const [pallettitleColorGradient, setPallettitleColorGradient] = useState(false);
                
                const [subtitleColor, setsubtitleColor] = useState(leadThemeObject?.thankYouPage?.subtitleColor);
                const [palletsubtitleColor, setPalletsubtitleColor] = useState(false);
                const [palletsubtitleColorGradient, setPalletsubtitleColorGradient] = useState(false);
                
  const [activeSettingContentsTitleCard, setActiveSettingContentsTitleCard] = useState("titleLabels");

  const ChooseCTAArr=[{title:"Refer & Earn",value:"refer"},{title:"Connect With Us",value:"connectWithUs"},{title:"Free Download",value:"freeDownload"},
                                     {title:"Join Webinar",value:"joinWebinar"}
                                     ,{title:"Free Test",value:"freeTest"},{title:"Free Course",value:"freeCourse"}
                                     ,{title:"Upsell/Downsell",value:"upsell"},{title:"Join Group",value:"joinGroup"},{title:"NewsLetter",value:"newsLetter"}
                                     ,{title:"Coupon Code",value:"couponCode"},{title:"Wallet Recharge",value:"walletRecharge"}
                                   ]
                                      function getCTATitle(value) {
  const found = ChooseCTAArr?.find(item => item?.value === value);
  return found ? found?.title : "Unknown";
}
    return (<><div style={{padding:"15px",marginTop:"5px",}}><h2> Thank You (+ CTA) Editor </h2></div>
                <div className="scroll-lf-settings" style={{marginTop:"-15px"}} >


<div style={{background:"#ffffff",display:"flex",justifyContent:"space-around",borderRadius:"15px",marginBottom:"10px",paddingTop:"0px"}}>  
                {/* {blockType=="design"? */}
                 
                  {/* :""} */}
                    <div style={{border:activeSettingContentsTitleCard=="titleLabels"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"130px",color:activeSettingContentsTitleCard=="titleLabels"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                  fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" , boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                  onClick={()=>{setActiveSettingContentsTitleCard("titleLabels")}}
                   onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                  >Thank You Titles & Styles</div>  
                   <div style={{border:activeSettingContentsTitleCard=="CTA"?"3px solid rgba(144, 202, 249,1)":"#ffffff",width:"100px",color:activeSettingContentsTitleCard=="CTA"?"#222222":"#222222",borderRadius:"15px",fontSize:"13px",
                    fontWeight:"bold",padding:"8px",paddingTop:"10px",margin:"5px",cursor:"pointer",display:"flex",justifyContent:"center",alignItems:"center" ,
                        boxShadow:"0 7px 20px 0 rgba(1,1,1,0.0401)"}}
                        onClick={()=>{setActiveSettingContentsTitleCard("CTA")}}
                         onMouseEnter={
                      ()=>handleMouseEnter("","","")}
      onMouseLeave={handleMouseLeave} 
                        > Choose CTA  </div>  
                           
                   
                  
                   
               </div>

               {activeSettingContentsTitleCard=="titleLabels"?<>
                <div className="lf-title-box-outer">
               <div className="lf-title-head-style">Lead Form Title Settings</div>
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Lead Form Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.title} onChange={(e)=>{setLeadObjectFields('thankYouPage',"title",e.target.value)}} />
 </div>   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Lead Form Subtitle`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"description",e.target.value)}} />
</div>

 {cardBG? <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"10px",padding:"10px",}}>
                       <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>{leadThemeObject?.thankYouPage?.cardBG?.title} </h4>
                                                          <div style={{width:"100px"}}>  <div style={{display:"flex",justifyContent:"space-between"}}>
                                                           <div></div>
                                                    {palletcardBGGradient||palletcardBG?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:"#fff"}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <X onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                    
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletcardBG?"yes":""}
                                                   className="input-textbox"  value={palletcardBGGradient}  name="palletItem1BGGradient1"  
                                                   onChange={e=>{setPalletcardBGGradient(false);setPalletcardBG(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>:""}
                                                         {palletcardBGGradient?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cardBG?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletcardBG?"yes":""}
                                                   className="input-textbox"  value={palletcardBG}  name="palletItem1BG1"  
                                                   onChange={e=>{setPalletcardBG(true);setPalletcardBGGradient(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                         :palletcardBG?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cardBG?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletcardBG?"yes":""}
                                                   className="input-textbox"  value={palletcardBGGradient}  name="palletItem1BGGradient1"  
                                                   onChange={e=>{setPalletcardBGGradient(true);setPalletcardBG(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>:<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:cardBG?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletcardBG?"yes":""}
                                                   className="input-textbox"  value={palletcardBG}  name="palletItem1BG1"  
                                                   onChange={e=>{setPalletcardBG(true);setPalletcardBGGradient(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                        </div></div></div>
                                                        
                 {palletcardBG?<>
                  <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={leadThemeObject?.cardBG} setActiveColorPickerValue={(color)=>{
                 setLeadObjectFields('thankYouPage',"cardBG",{...leadThemeObject?.thankYouPage?.cardBG,color:color?.color});setcardBG(color);
                 // console.log(color)
                 }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.thankYouPage?.cardBG?.title}/> 
                 </div></>:palletcardBGGradient?<>
                  <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={leadThemeObject?.cardBG} setActiveColorPickerValue={(color)=>{
               setLeadObjectFields('thankYouPage',"cardBG",{...leadThemeObject?.thankYouPage?.cardBG,color:color?.color});setcardBG(color);
                 // console.log(color)
                 }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.cardBG?.title}/> 
                 </div></>:"" }
  
  
                 </div>
                 :""}  
{titleColor? <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"10px",padding:"10px",}}>
                     <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>{leadThemeObject?.thankYouPage?.titleColor?.title} </h4>
                                                        <div style={{width:"100px"}}>  <div style={{display:"flex",justifyContent:"space-between"}}>
                                                         <div></div>
                                                  {pallettitleColorGradient||pallettitleColor?<label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:"#fff"}}>
                                                                          <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                          
                                                                           <X onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                  
                                                                           </div> 
                                                            <input type="checkbox" title="Color Theme"   checked={pallettitleColor?"yes":""}
                                                 className="input-textbox"  value={pallettitleColorGradient}  name="palletItem1BGGradient1"  
                                                 onChange={e=>{setPallettitleColorGradient(false);setPallettitleColor(false);}}/>
                                                      <span class={"boxCardBorder-two"} style={{}}></span> </label>:""}
                                                       {pallettitleColorGradient?<label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:titleColor?.color}}>
                                                                          <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                          
                                                                           <Palette onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                   
                                                                           </div> 
                                                            <input type="checkbox" title="Color Theme"   checked={pallettitleColor?"yes":""}
                                                 className="input-textbox"  value={pallettitleColor}  name="palletItem1BG1"  
                                                 onChange={e=>{setPallettitleColor(true);setPallettitleColorGradient(false);}}/>
                                                      <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                       :pallettitleColor?<label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:titleColor?.color}}>
                                                                          <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                          
                                                                           <Palette onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                           <Palette onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                   
                                                                           </div> 
                                                            <input type="checkbox" title="Color Theme"   checked={pallettitleColor?"yes":""}
                                                 className="input-textbox"  value={pallettitleColorGradient}  name="palletItem1BGGradient1"  
                                                 onChange={e=>{setPallettitleColorGradient(true);setPallettitleColor(false);}}/>
                                                      <span class={"boxCardBorder-two"} style={{}}></span> </label>:<label onMouseEnter={
                                                                           ()=>handleMouseEnter("#fff","#333","")}
                                                            onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:titleColor?.color}}>
                                                                          <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                          
                                                                           <Palette onMouseEnter={handleMouseEnter}
                                                                                                   onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                   
                                                                           </div> 
                                                            <input type="checkbox" title="Color Theme"   checked={pallettitleColor?"yes":""}
                                                 className="input-textbox"  value={pallettitleColor}  name="palletItem1BG1"  
                                                 onChange={e=>{setPallettitleColor(true);setPallettitleColorGradient(false);}}/>
                                                      <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                      </div></div></div>
                                                      
               {pallettitleColor?<>
                <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={leadThemeObject?.thankYouPage?.titleColor} setActiveColorPickerValue={(color)=>{
               setLeadObjectFields('thankYouPage',"titleColor",{...leadThemeObject?.thankYouPage?.titleColor,color:color?.color});settitleColor(color);
               // console.log(color)
               }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.thankYouPage?.titleColor?.title}/> 
               </div></>:pallettitleColorGradient?<>
                <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={leadThemeObject?.thankYouPage?.titleColor} setActiveColorPickerValue={(color)=>{
             setLeadObjectFields('thankYouPage',"titleColor",{...leadThemeObject?.thankYouPage?.titleColor,color:color?.color});settitleColor(color);
               // console.log(color)
               }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.thankYouPage?.titleColor?.title}/> 
               </div></>:"" }
 

               </div>
               :""}
                {subtitleColor? <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"10px",padding:"10px",}}>
                       <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>{leadThemeObject?.thankYouPage?.subtitleColor?.title} </h4>
                                                          <div style={{width:"100px"}}>  <div style={{display:"flex",justifyContent:"space-between"}}>
                                                           <div></div>
                                                    {palletsubtitleColorGradient||palletsubtitleColor?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:"#fff"}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <X onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                    
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletsubtitleColor?"yes":""}
                                                   className="input-textbox"  value={palletsubtitleColorGradient}  name="palletItem1BGGradient1"  
                                                   onChange={e=>{setPalletsubtitleColorGradient(false);setPalletsubtitleColor(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>:""}
                                                         {palletsubtitleColorGradient?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:subtitleColor?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletsubtitleColor?"yes":""}
                                                   className="input-textbox"  value={palletsubtitleColor}  name="palletItem1BG1"  
                                                   onChange={e=>{setPalletsubtitleColor(true);setPalletsubtitleColorGradient(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>
                                                         :palletsubtitleColor?<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:subtitleColor?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletsubtitleColor?"yes":""}
                                                   className="input-textbox"  value={palletsubtitleColorGradient}  name="palletItem1BGGradient1"  
                                                   onChange={e=>{setPalletsubtitleColorGradient(true);setPalletsubtitleColor(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>:<label onMouseEnter={
                                                                             ()=>handleMouseEnter("#fff","#333","")}
                                                              onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} style={{background:subtitleColor?.color}}>
                                                                            <div style={{display:"flex",justifyContent:"space-between",}} >
                                                                            
                                                                             <Palette onMouseEnter={handleMouseEnter}
                                                                                                     onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color={"#555"} size={22}/>
                                                                                                     
                                                                             </div> 
                                                              <input type="checkbox" title="Color Theme"   checked={palletsubtitleColor?"yes":""}
                                                   className="input-textbox"  value={palletsubtitleColor}  name="palletItem1BG1"  
                                                   onChange={e=>{setPalletsubtitleColor(true);setPalletsubtitleColorGradient(false);}}/>
                                                        <span class={"boxCardBorder-two"} style={{}}></span> </label>}
                                                        </div></div></div>
                                                        
                 {palletsubtitleColor?<>
                  <div style={{position:"relative",right:"0px",zIndex:"9999999"}}><ColorPickerDynamicTwo activeColorPickerValue={leadThemeObject?.subtitleColor} setActiveColorPickerValue={(color)=>{
                 setLeadObjectFields('thankYouPage',"subtitleColor",{...leadThemeObject?.thankYouPage?.subtitleColor,color:color?.color});setsubtitleColor(color);
                 // console.log(color)
                 }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.subtitleColor?.title}/> 
                 </div></>:palletsubtitleColorGradient?<>
                  <div style={{position:"relative",right:"5px",zIndex:"9999999"}}><ColorPickerGradientDynamic activeColorPickerValue={leadThemeObject?.subtitleColor} setActiveColorPickerValue={(color)=>{
               setLeadObjectFields('thankYouPage',"subtitleColor",{...leadThemeObject?.thankYouPage?.subtitleColor,color:color?.color});setsubtitleColor(color);
                 // console.log(color)
                 }} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.subtitleColor?.title}/> 
                 </div></>:"" }
  
  
                 </div>
                 :""} 

                 
                 
                     <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                                     <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                                      paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                                         <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:leadThemeObject?.thankYouPage?.titleFont?.family?.fontFamily}}>
                                                             Title Font Family:    "{leadThemeObject?.thankYouPage?.titleFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                                  ()=>handleMouseEnter("#fff","#333","")}
                                                                   onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                                 <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                                 
                                                                                  <Languages onMouseEnter={handleMouseEnter}
                                                                                                          onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                                          
                                                                                  </div> 
                                                                   <input type="checkbox" title=""   checked={fontFamilySubTitlePopup?"yes":""}
                                                        className="input-textbox"  value={"k"}  name="fintFamily1"  
                                                        onChange={e=>{setFontFamilySubTitlePopup(e.target.checked);}}/>
                                                             <span class={"boxCardBorder-two"}></span> </label>
                                     {fontFamilySubTitlePopup?
                                       <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                                      <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                                      paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                                       <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:leadThemeObject?.thankYouPage?.titleFont?.family?.fontFamily}}>
                                                         Font :   "{leadThemeObject?.thankYouPage?.titleFont?.family?.name}"</div>  </div>
                                                      <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                                       
                                                         {fonts?.map((item,index) => (
                                                        <>  <label onMouseEnter={
                                                                                  ()=>handleMouseEnter("#fff","#333","")}
                                                                   onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                                 <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                                  <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                                          <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                                  </div> 
                                                                   <input type="radio" title=""   checked={leadThemeObject?.thankYouPage?.titleFont?.family?.name==item?.name?"yes":""}
                                                        className="input-textbox"  value={item?.name}  name="FontFamily1"  
                                                        onClick={e=>{setLeadObjectFields('thankYouPage','titleFont',{...leadThemeObject?.thankYouPage?.titleFont,family:item},item)}}/>
                                                             <span class={"boxCardBorder-two"}></span> </label> </>
                                                         ))}
                                                         </div></div>:""}</div></div> 
                                                         
                     <div style={{background:"#ffffff",borderRadius:"15px",padding:"0px",marginTop:"10px",padding:"5px",display:"flex",justifyContent:"space-between",}}>
                                                     <div style={{fontSize:"18px",fontWeight:"bold",padding:"5px",marginTop:"15px",
                                                      paddingLeft:"10px",display:"flex",justifyContent:"left",width:"320px"}}>
                                                         <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily}}>
                                                            SubTitle  Font Family:    "{leadThemeObject?.thankYouPage?.subtitleFont?.family?.name}"</div>  </div><div style={{paddingTop:"10px",position:"relative"}}> <label onMouseEnter={
                                                                                  ()=>handleMouseEnter("#fff","#333","")}
                                                                   onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                                 <div style={{display:"flex",justifyContent:"space-between"}} >
                                                                                 
                                                                                  <Languages onMouseEnter={handleMouseEnter}
                                                                                                          onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#555" size={22}/>
                                                                                                          
                                                                                  </div> 
                                                                   <input type="checkbox" title=""   checked={fontFamilyTitlePopup?"yes":""}
                                                        className="input-textbox"  value={"k"}  name="fintFamily1"  
                                                        onChange={e=>{setFontFamilyTitlePopup(e.target.checked);}}/>
                                                             <span class={"boxCardBorder-two"}></span> </label>
                                     {fontFamilyTitlePopup?
                                       <div  style={{position:"absolute",borderRadius:"15px",right:"-5px",bottom:"70px",zIndex:"9999999",background:"#ffffff",}}>
                                      <div style={{fontSize:"18px",borderRadius:"5px",background:" rgba(144, 202, 249,0.31)",fontWeight:"bold",padding:"10px",marginTop:"5px",
                                                      paddingLeft:"10px",display:"flex",justifyContent:"left",}}>
                                                       <div style={{fontSize:"14px",padding:"2px",marginLeft:"10px",fontFamily:leadThemeObject?.thankYouPage?.subtitleFont?.family?.fontFamily}}>
                                                         Font :   "{leadThemeObject?.thankYouPage?.subtitleFont?.family?.name}"</div>  </div>
                                                      <div  className="colorPickerDynamic" style={{borderRadius:"15px",height:"250px",overflowY:"auto",margin:"0px",background:"rgba(144, 202, 249,0.1)",padding:"5px",width:"220px",}}>
                                                       
                                                         {fonts?.map((item,index) => (
                                                        <>  <label onMouseEnter={
                                                                                  ()=>handleMouseEnter("#fff","#333","")}
                                                                   onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                                                 <div style={{display:"flex",justifyContent:"left",alignItems:"left"}} >
                                                                                  <div style={{width:"40px"}}><LanguagesIcon color={"#333"} size={24}/></div>  
                                                                                          <div style={{fontSize:"16px",fontFamily:item?.fontFamily}}> {item?.name} </div>              
                                                                                  </div> 
                                                                   <input type="radio" title=""   checked={leadThemeObject?.thankYouPage?.subtitleFont?.family?.name==item?.name?"yes":""}
                                                        className="input-textbox"  value={item?.name}  name="FontFamily1"  
                                                        onClick={e=>{setLeadObjectFields('thankYouPage','subtitleFont',{...leadThemeObject?.thankYouPage?.subtitleFont,family:item},item)}}/>
                                                             <span class={"boxCardBorder-two"}></span> </label> </>
                                                         ))}
                                                         </div></div>:""}</div></div>    
 </div></>
               :activeSettingContentsTitleCard=="CTA"?<>
               <div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"15px",padding:"10px",}}>
                 <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>{leadThemeObject?.thankYouPage?.CTAButton?.title} </h4>
                                  <DropDownButtonUI activeCard={""} icon={2} title={leadThemeObject?.thankYouPage?.CTAButton?.type} 
                                  onClickSendObject={(value)=>{if(value){setLeadObjectFields('thankYouPage',"CTAButton",
                                     {...leadThemeObject?.thankYouPage?.CTAButton,type:value});setCTAState(value)}}}
                                   hasDropDown={true} dropDownObject={ChooseCTAArr} />                        
               
               
               
               </div>  </div>
                <div className="lf-title-box-outer">
               <div className="lf-title-head-style">{getCTATitle(CTAState)} Settings</div>
               {CTAState=="refer"?<div>
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Refer Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.refer?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    refer: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.refer,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Refer Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.refer?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
    refer: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.refer,
      description: e.target.value,
    },
  })}} />
</div>
 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Refer Button Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.refer?.buttonTitle} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    refer: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.refer,
      buttonTitle: e.target.value,
    },
  }
);}} />
                      
 <label onMouseEnter={
                                                            ()=>handleMouseEnter("#fff","#333","")}
                                             onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{background:leadThemeObject?.thankYouPage?.CTAButton?.refer?.buttonBG?.color,top:"10px",height:"23px"}}>
                                                           <div style={{display:"flex",justifyContent:"space-between"}} >
                                                           
                                                            <Palette onMouseEnter={handleMouseEnter}
                                                                                    onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#ffffff" size={22}/>
                                                                                    
                                                            </div> 
                                             <input type="checkbox" title="Color Theme"   checked={palletItem1BorderBG?"yes":""}
                                  className="input-textbox"  value={palletItem1BorderBG}  name="palletItem1BorderBG1"  
                                  onChange={e=>{setPalletItem1BorderBG(e.target.checked);;}}/>
                                       <span class={"boxCardBorder-two"}></span> </label>
{palletItem1BorderBG?<>
 <div style={{position:"absolute",right:"-5px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic 
 activeColorPickerValue={leadThemeObject?.thankYouPage?.CTAButton?.refer?.buttonBG} setActiveColorPickerValue={(color)=>{
setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    refer: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.refer,
      buttonBG: color,
    },
  });}} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.borderImage?.borderColor?.title} /> 
</div></>:"" }
 </div> 



</div>:""} 


    {CTAState=="connectWithUs"?<div>
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Connect With Us Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    connectWithUs: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Connect With Us Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
   connectWithUs: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs,
      description: e.target.value,
    },
  })}} />
</div>


 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Facebook Link`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.fb?.link} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    connectWithUs: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs,
      fb:{...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs.fb,link:e.target.value} ,
    },
  }
);}} />
 </div> 

 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Youtube Link`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.YT?.link} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    connectWithUs: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs,
      YT:{...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.YT,link:e.target.value}
    },
  }
);}} />
 </div> 


 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`X Link`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.X?.link} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    connectWithUs: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs,
      X:{...leadThemeObject?.thankYouPage?.CTAButton?.connectWithUs?.X,link:e.target.value}
    },
  }
);}} />
 </div> 


</div>:""} 

    {CTAState=="freeDownload"?<div>
               <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Connect With Us Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    freeDownload: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeDownload,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Connect With Us Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
   freeDownload: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeDownload,
      description: e.target.value,
    },
  })}} />
</div>

 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Free Download Button Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.buttonTitle} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    freeDownload: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeDownload,
      buttonTitle: e.target.value,
    },
  }
);}} />
                      
 <label onMouseEnter={
                                                            ()=>handleMouseEnter("#fff","#333","")}
                                             onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}style={{background:leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.buttonBG?.color,top:"10px",height:"23px"}}>
                                                           <div style={{display:"flex",justifyContent:"space-between"}} >
                                                           
                                                            <Palette onMouseEnter={handleMouseEnter}
                                                                                    onMouseLeave={handleMouseLeave}  onClick={()=>{ }} style={{position:"relative"}}   color="#ffffff" size={22}/>
                                                                                    
                                                            </div> 
                                             <input type="checkbox" title="Color Theme"   checked={palletItem1BorderBG?"yes":""}
                                  className="input-textbox"  value={palletItem1BorderBG}  name="palletItem1BorderBG1"  
                                  onChange={e=>{setPalletItem1BorderBG(e.target.checked);;}}/>
                                       <span class={"boxCardBorder-two"}></span> </label>
{palletItem1BorderBG?<>
 <div style={{position:"absolute",right:"-5px",bottom:"70px",zIndex:"9999999"}}><ColorPickerDynamic 
 activeColorPickerValue={leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.buttonBG} setActiveColorPickerValue={(color)=>{
setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    freeDownload: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeDownload,
      buttonBG: color,
    },
  });}} colorPickerOptionArray={[]}   palletTitle={leadThemeObject?.borderImage?.borderColor?.title} /> 
</div></>:"" }
 </div>
 
  <div className="lf-title-box-outer">
   <div  style={{display:"flex",justifyContent:"space-between",marginTop:"5px",background:"rgba(144, 202, 249,0.31) ",borderRadius:"20px",paddingLeft:"10px",paddingRight:"10px"}}>
             <ImageWithFallback src={leadThemeObject?.image?.src} widthOuter={"70px"} fireOpenEdit ={()=>{}}  iconSize={44}  setOpenFullImg={()=>{}}/>
                <h5 style={{marginTop:"29px",width:"200px"}}>Upload Downloadable File </h5> 
           
            </div> 
            
             
            
             </div> 
<div style={{background:"#ffffff",borderRadius:"15px",marginLeft:"3px",marginRight:"3px",marginTop:"15px",padding:"10px",}}>
                 <div style={{display:"flex",justifyContent:"space-between",position:"relative"}}><h4>Choose Download Type </h4>
                                  <DropDownButtonUI activeCard={""} icon={2} title={leadThemeObject?.thankYouPage?.CTAButton?.freeDownload?.downloadType} 
                                  onClickSendObject={(value)=>{if(value){setLeadObjectFields('thankYouPage',"CTAButton",
                                     {...leadThemeObject?.thankYouPage?.CTAButton,freeDownload:{...leadThemeObject?.thankYouPage?.CTAButton?.freeDownload,downloadType:value}});}}}
                                   hasDropDown={true} dropDownObject={[{title:"Send To Email",value:"sendToEmail"},{title:"Instant Download",value:"Instant"},]} />                        
               
               
               
               </div>  </div>

</div>:""} 
 {CTAState=="joinWebinar"?<div>

           <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Join Webinar Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.joinWebinar?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    joinWebinar: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.joinWebinar,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Join Webinar Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.joinWebinar?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
   joinWebinar: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.joinWebinar,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
 {CTAState=="freeTest"?<div>
        <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Free Test Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeTest?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    freeTest: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeTest,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Free Test Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeTest?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
   freeTest: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeTest,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
 {CTAState=="freeCourse"?<div>
       <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Free Course Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeCourse?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    freeCourse: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeCourse,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Free CourseText Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.freeCourse?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
   freeCourse: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.freeCourse,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
 {CTAState=="upsell"?<div> 
       <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Upsell Course Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.upsell?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    upsell: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.upsell,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Upsell Course Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.upsell?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
  upsell: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.upsell,
      description: e.target.value,
    },
  })}} />
</div>
</div>:""} 
 {CTAState=="joinGroup"?<div>

     <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Join Group Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.joinGroup?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    joinGroup: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.joinGroup,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Join Group Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.joinGroup?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
  joinGroup: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.joinGroup,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
 {CTAState=="newsLetter"?<div>
 <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`NewsLetter Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.newsLetter?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    newsLetter: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.newsLetter,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`NewsLetter Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.newsLetter?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
  newsLetter: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.newsLetter,
      description: e.target.value,
    },
  })}} />
</div>

 </div>:""} 
 {CTAState=="couponCode"?<div>
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Coupon Code Text Title`} type="text"
  rows={1} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.couponCode?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    couponCode: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.couponCode,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Coupon Code Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.couponCode?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
 couponCode: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.couponCode,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
 {CTAState=="walletRecharge"?<div>
     <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
               <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Wallet Recharge Text Title`} type="text"
  rows={2} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.walletRecharge?.title} 
  onChange={(e)=>{setLeadObjectFields(
  "thankYouPage",
  "CTAButton",
  {
    ...leadThemeObject?.thankYouPage?.CTAButton,
    walletRecharge: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.walletRecharge,
      title: e.target.value,
    },
  }
);}} />
 </div> 
    
 
 
   <div style={{position:"relative",display:"flex",justifyContent:"space-between"}}>
                 <textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="LeadInfoCardTextBox"  style= {{fontSize:"16px",padding:"10px",width:"100%",}} placeholder={`Wallet Recharge Text Description`} type="text"
  rows={3} name="courseTitle" value={leadThemeObject?.thankYouPage?.CTAButton?.walletRecharge?.description} onChange={(e)=>{setLeadObjectFields('thankYouPage',"CTAButton"
  ,{
    ...leadThemeObject?.thankYouPage?.CTAButton,
 walletRecharge: {
      ...leadThemeObject?.thankYouPage?.CTAButton?.walletRecharge,
      description: e.target.value,
    },
  })}} />
</div>
 </div>:""} 
</div>
               </>:""}
</div>
     <style>{ `
    

        
/* md */
@media (min-width: 992px) and (max-width: 1199px) {
}
/* sm */
@media (min-width: 768px) and (max-width: 991px) {
}
/* xs */
@media (max-width: 767px) {
}
        `}
        </style>
    </>)
}

export default EditorThankYouAndCTA;